//basic
import React from 'react'
import { toJS } from 'mobx'
import { observer, inject } from 'mobx-react'

//api
import { api } from '../../../functions/api'

//custom components
import CustomInput from '../../../components/basic/input'
import CustomButton from '../../../components/basic/CustomButton'
// import CustomAvatar from '../../../components/basic/customAvatar';
// import SelectSearch from '../../../components/basic/SelectSearch/SelectSearch';
import CustomIconButton from '../../../components/basic/customIconButton'
import DeleteDialog from '../../../components/global/deleteDialog'

//material-ui
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Button,
  CircularProgress,
  Grid,
  createMuiTheme,
  MuiThemeProvider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  InputBase,
} from '@material-ui/core'

//style
import './ShowServiceProtol.scss'

//other libraries
import Icon from '@mdi/react'
import { mdiDotsVertical } from '@mdi/js'

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiFormControl: {
      root: {
        width: '100%',
      },
    },
    MuiFormLabel: {
      root: {
        color: 'rgba(0, 0, 0, 0.54) !important',
      },
      focused: {
        color: 'rgba(0, 0, 0, 0.54) !important',
      },
    },
    MuiInput: {
      // underline: {
      //     "&:before": {
      //         borderBottomStyle: 'solid',
      //         borderBottomColor: "rgba(0, 0, 0, 0.54) !important"
      //     }
      // },
      disabled: {
        '&:before': {
          borderBottomStyle: 'solid !important',
          borderBottomColor: 'rgba(0, 0, 0, 0.54) !important',
        },
      },
    },
  },
})


@inject('translate')
@inject('internal')
@observer
export default class ShowServiceProtocol extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loadingBtn: false,
      loading: true,
      data: {},
    }
  }
  
  componentDidMount() {
    let actionEdit = toJS(this.props.internal.actionEdit)
    
    if (actionEdit.id !== null) {
      Promise.all([
        this.loadCustomerOrderDetail(actionEdit.id),
      ]).then(() => {
        this.setState({ loading: false })
      })
      
    }
    
  }
  
  loadCustomerOrderDetail = async (idCustomer) => {
    let load_data = await api({
      method: 'get',
      url: `customer-orders/${idCustomer}`,
      authorization: this.props.internal.user.access_token,
    })
    
    if (load_data.success === true) {
      this.setState({ data: load_data.data.data })
    }
  }
  
  action = () => {
    this.setState({ loadingBtn: true })
    this.updateCustomerData()
  }
  
  updateCustomerData = async () => {
    
    let idCustomerOrder = toJS(this.props.internal.actionEdit.id)
    
    let data = {}
    if (this.billing_first_name.state.value !== '') {
      data.billing_first_name = this.billing_first_name.state.value
    }
    if (this.billing_last_name.state.value !== '') {
      data.billing_last_name = this.billing_last_name.state.value
    }
    if (this.billing_company_name.state.value !== '') {
      data.billing_company_name = this.billing_company_name.state.value
    }
    if (this.billing_id_no.state.value !== '') {
      data.billing_id_no = this.billing_id_no.state.value
    }
    if (this.billing_id_tax.state.value !== '') {
      data.billing_id_tax = this.billing_id_tax.state.value
    }
    if (this.billing_id_vat.state.value !== '') {
      data.billing_id_vat = this.billing_id_vat.state.value
    }
    if (this.billing_city.state.value !== '') {
      data.billing_city = this.billing_city.state.value
    }
    
    if (this.state.data.billing_country_id) {
      data.billing_country_id = this.state.data.billing_country_id
    }
    
    if (this.billing_phone.state.value !== '') {
      data.billing_phone = this.billing_phone.state.value
    }
    
    if (this.billing_street.state.value !== '') {
      data.billing_street = this.billing_street.state.value
    }
    
    if (this.billing_zip.state.value !== '') {
      data.billing_zip = this.billing_zip.state.value
    }
    
    if (this.billing_email.state.value !== '') {
      data.billing_email = this.billing_email.state.value
    }
    
    data.note = this.note.state.value
    
    if (this.delivery_first_name.state.value !== '') {
      data.delivery_first_name = this.delivery_first_name.state.value
    }
    if (this.delivery_last_name.state.value !== '') {
      data.delivery_last_name = this.delivery_last_name.state.value
    }
    if (this.delivery_city.state.value !== '') {
      data.delivery_city = this.delivery_city.state.value
    }
    
    if (this.state.data.delivery_country_id) {
      data.delivery_country_id = this.state.data.delivery_country_id
    }
    
    if (this.delivery_phone.state.value !== '') {
      data.delivery_phone = this.delivery_phone.state.value
    }
    
    if (this.delivery_street.state.value !== '') {
      data.delivery_street = this.delivery_street.state.value
    }
    
    if (this.delivery_zip.state.value !== '') {
      data.delivery_zip = this.delivery_zip.state.value
    }
    if (this.delivery_email.state.value !== '') {
      data.delivery_email = this.delivery_email.state.value
    }
    
    let params = data
    
    
    let update_data = await api({
      method: 'patch',
      
      // TODO: vymazat ked budu testovacie
      // postman: true,
      
      url: `customer-orders/${idCustomerOrder}`,
      authorization: this.props.internal.user.access_token,
      params,
    })
    
    if (update_data.success === true) {
      this.props.internal.setSnackbar(update_data.data.message, true)
      this.props.onClose(true)
    } else {
      this.props.internal.setSnackbar(update_data.data.message, true)
    }
    
    this.setState({ loadingBtn: false })
  }
  
  
  handleChangePhoto = async (data) => {
    let idFixedSet = toJS(this.props.internal.actionEdit.id)
    
    if (idFixedSet !== null) {
      this.setState({ loadingBtn: true })
      let upload_data = await api({
        method: 'post',
        url: `products/static-sets/${idFixedSet}`,
        formData: true,
        
        authorization: this.props.internal.user.access_token,
        params: {
          photo: data,
        },
        
      })
      
      if (upload_data.success && upload_data.success === true) {
        // this.props.internal.photoWasChanged(false)
        this.props.internal.setSnackbar(upload_data.data.message, true)
        this.setState({ loadingBtn: false })
        return Promise.resolve(false)
      } else {
        this.props.internal.setSnackbar(upload_data.data.message, true)
      }
    } else {
    
    }
  }
  
  formatMoney = (data) => {
    const formatter = new Intl.NumberFormat('sk-SK', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
    })
    return formatter.format(data)
  }
  
  handleCountry = (field, val) => {
    let tmpData = this.state.data
    tmpData[field] = val.target.value
    this.setState({ data: tmpData })
  }
  
  detail = [
    {
      title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
      action: 'delete',
    },
  ]
  
  handleDelete = async () => {
    
    let actionDeleteObj = toJS(this.props.internal.actionDeleteObj)
    let actionEdit = toJS(this.props.internal.actionEdit)
    
    let id = actionEdit.id
    
    
    let params = {}
    if (actionDeleteObj.id.product_id !== null && actionDeleteObj.id.static_set_id === null) {
      params.product_id = actionDeleteObj.id.product_id
    } else {
      params.static_set_id = actionDeleteObj.id.static_set_id
    }
    
    
    let delete_data = await api({
      method: 'DELETE',
      url: `customer-orders/${id}/item-remove`,
      authorization: this.props.internal.user.access_token,
      params: params,
    })
    
    if (delete_data.success === true) {
      this.setState({ data: delete_data.data.data })
      this.props.internal.setSnackbar(delete_data.data.message, true)
      this.props.internal.setActionDeleteObj(
        {
          module: null,
          id: null,
        },
      )
      
      this.props.internal.setActionDelete()
    }
    
  }
  
  timeout = null
  handleChangeQuantity = (item, val) => {
    let quantity = val.target.value
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.updateQuantity(item, quantity)
    }, 1000)
  }
  
  updateQuantity = async (item, quantity) => {
    let id = toJS(this.props.internal.actionEdit.id)
    
    let params = {
      quantity: quantity,
    }
    if (item.product_id !== null && item.static_set_id === null) {
      params.product_id = item.product_id
    } else {
      params.static_set_id = item.static_set_id
    }
    
    let update_data = await api({
      method: 'PATCH',
      url: `customer-orders/${id}/item-quantity`,
      authorization: this.props.internal.user.access_token,
      params: params,
    })
    
    if (update_data.success === true) {
      this.props.internal.setSnackbar(update_data.data.message, true)
      this.setState({ data: update_data.data.data })
    } else {
      this.props.internal.setSnackbar(update_data.data.message, true)
    }
  }
  
  render() {
    return (
      <MuiThemeProvider theme={theme}>
        {(toJS(this.props.internal.actionEdit.edit === true)) && (toJS(this.props.internal.actionDelete === true)) &&
        <DeleteDialog
          open={this.props.internal.actionDelete}
          title={this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].DELETE_ITEM}
          content={this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
          btn_cancel={this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
          btn_delete={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
          delete={this.handleDelete}
        />
        }
        <Dialog
          open={this.props.open}
          onClose={() => this.props.onClose(false)}
          aria-labelledby="form-dialog-title"
          classes={{
            root: 'addEditFixedSetDialog-root',
            paper: 'addEditFixedSetDialog-paper',
          }}
          maxWidth={'md'}
          fullWidth={true}
        >
          <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
          {this.state.loading
            ?
            <div style={{ minHeight: '100px' }}>
              <CircularProgress className={'circular-progress'}/>
            </div>
            :
            <DialogContent classes={{ root: '' }}>
              <Grid container spacing={8}>
                <Grid item xs={12} sm={6}>
                  <Grid container>
                    <Grid item xs={12}>
                      <h2 className={'titleAddress'}>{this.props.translate.i18n.MODULES.CUSTOMERS.BILLING_ADDRESS}</h2>
                    </Grid>
                    <Grid item xs={12}>
                      <CustomInput
                        ref={ref => this.billing_first_name = ref}
                        text={this.props.translate.i18n.GLOBAL.USER.FIRST_NAME}
                        value={this.state.data !== null ? this.state.data.billing_first_name : ''}
                        id={'billing_first_name'}
                        className={'w-100'}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CustomInput
                        ref={ref => this.billing_last_name = ref}
                        text={this.props.translate.i18n.GLOBAL.USER.LAST_NAME}
                        value={this.state.data !== null ? this.state.data.billing_last_name : ''}
                        id={'billing_last_name'}
                        className={'w-100'}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CustomInput
                        ref={ref => this.billing_company_name = ref}
                        text={this.props.translate.i18n.MODULES.CUSTOMERS_ORDERS.COMPANY_NAME}
                        value={this.state.data !== null ? this.state.data.billing_company_name : ''}
                        id={'billing_company_name'}
                        className={'w-100'}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CustomInput
                        ref={ref => this.billing_id_no = ref}
                        text={this.props.translate.i18n.MODULES.CUSTOMERS_ORDERS.ID_NO}
                        value={this.state.data !== null ? this.state.data.billing_id_no : ''}
                        id={'billing_id_no'}
                        className={'w-100'}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CustomInput
                        ref={ref => this.billing_id_tax = ref}
                        text={this.props.translate.i18n.MODULES.CUSTOMERS_ORDERS.ID_TAX}
                        value={this.state.data !== null ? this.state.data.billing_id_tax : ''}
                        id={'billing_id_tax'}
                        className={'w-100'}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CustomInput
                        ref={ref => this.billing_id_vat = ref}
                        text={this.props.translate.i18n.MODULES.CUSTOMERS_ORDERS.ID_VAT}
                        value={this.state.data !== null ? this.state.data.billing_id_vat : ''}
                        id={'billing_id_vat'}
                        className={'w-100'}
                      />
                    </Grid>
                    
                    <Grid item xs={12}>
                      <CustomInput
                        ref={ref => this.billing_street = ref}
                        text={this.props.translate.i18n.GLOBAL.ADRESS.ADRESS}
                        value={this.state.data !== null ? this.state.data.billing_street : ''}
                        id={'billing_street'}
                        className={'w-100'}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CustomInput
                        ref={ref => this.billing_zip = ref}
                        text={this.props.translate.i18n.GLOBAL.ADRESS.ZIP}
                        value={this.state.data !== null ? this.state.data.billing_zip : ''}
                        id={'billing_zip'}
                        className={'w-100'}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CustomInput
                        ref={ref => this.billing_city = ref}
                        text={this.props.translate.i18n.GLOBAL.ADRESS.CITY}
                        value={this.state.data !== null ? this.state.data.billing_city : ''}
                        id={'billing_city'}
                        className={'w-100'}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl>
                        <InputLabel htmlFor="billing_country_id">{this.props.translate.i18n.GLOBAL.ADRESS.COUNTRY}</InputLabel>
                        <Select
                          // className={'multiple-select '}
                          value={this.state.data && this.state.data !== null ? this.state.data.billing_country_id : 0}
                          onChange={(val) => this.handleCountry('billing_country_id', val)}
                          inputProps={{
                            name: 'billing_country_id',
                            id: 'billing_country_id',
                          }}
                        >
                          {toJS(this.props.internal.dataForTable.lists.countries).map(country => (
                            // <MenuItem key={country.id} value={country} title={country.title} >
                            <MenuItem key={country.id} value={country.id}>
                              {country.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <CustomInput
                        ref={ref => this.billing_phone = ref}
                        text={this.props.translate.i18n.GLOBAL.CONTACT.PHONE}
                        value={this.state.data !== null ? this.state.data.billing_phone : ''}
                        id={'billing_phone'}
                        className={'w-100'}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CustomInput
                        ref={ref => this.billing_email = ref}
                        text={this.props.translate.i18n.GLOBAL.CONTACT.EMAIL}
                        value={this.state.data !== null ? this.state.data.billing_email : ''}
                        id={'billing_email'}
                        className={'w-100'}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CustomInput
                        ref={ref => this.note = ref}
                        text={this.props.translate.i18n.GLOBAL.CONTACT.NOTE}
                        value={this.state.data !== null ? this.state.data.note : ''}
                        id={'note'}
                        multiline
                        className={'w-100'}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Grid container>
                    <Grid item xs={12}>
                      <h2 className={'titleAddress'}>{this.props.translate.i18n.MODULES.CUSTOMERS.DELIVERY_ADDRESS}</h2>
                    </Grid>
                    <Grid item xs={12}>
                      <CustomInput
                        ref={ref => this.delivery_first_name = ref}
                        text={this.props.translate.i18n.GLOBAL.USER.FIRST_NAME}
                        value={this.state.data !== null ? this.state.data.delivery_first_name : ''}
                        id={'delivery_first_name'}
                        className={'w-100'}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CustomInput
                        ref={ref => this.delivery_last_name = ref}
                        text={this.props.translate.i18n.GLOBAL.USER.LAST_NAME}
                        value={this.state.data !== null ? this.state.data.delivery_last_name : ''}
                        id={'delivery_last_name'}
                        className={'w-100'}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CustomInput
                        ref={ref => this.delivery_street = ref}
                        text={this.props.translate.i18n.GLOBAL.ADRESS.ADRESS}
                        value={this.state.data !== null ? this.state.data.delivery_street : ''}
                        id={'delivery_street'}
                        className={'w-100'}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CustomInput
                        ref={ref => this.delivery_zip = ref}
                        text={this.props.translate.i18n.GLOBAL.ADRESS.ZIP}
                        value={this.state.data !== null ? this.state.data.delivery_zip : ''}
                        id={'delivery_zip'}
                        className={'w-100'}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CustomInput
                        ref={ref => this.delivery_city = ref}
                        text={this.props.translate.i18n.GLOBAL.ADRESS.CITY}
                        value={this.state.data !== null ? this.state.data.delivery_city : ''}
                        id={'delivery_city'}
                        className={'w-100'}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl>
                        <InputLabel htmlFor="delivery_country_id">{this.props.translate.i18n.GLOBAL.ADRESS.COUNTRY}</InputLabel>
                        <Select
                          // className={'multiple-select '}
                          value={this.state.data && this.state.data !== null ? this.state.data.delivery_country_id : 0}
                          onChange={(val) => this.handleCountry('delivery_country_id', val)}
                          inputProps={{
                            name: 'delivery_country_id',
                            id: 'delivery_country_id',
                          }}
                        >
                          {toJS(this.props.internal.dataForTable.lists.countries).map(country => (
                            // <MenuItem key={country.id} value={country} title={country.title} >
                            <MenuItem key={country.id} value={country.id}>
                              {country.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <CustomInput
                        ref={ref => this.delivery_phone = ref}
                        text={this.props.translate.i18n.GLOBAL.CONTACT.PHONE}
                        value={this.state.data !== null ? this.state.data.delivery_phone : ''}
                        id={'delivery_phone'}
                        className={'w-100'}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CustomInput
                        ref={ref => this.delivery_email = ref}
                        text={this.props.translate.i18n.GLOBAL.CONTACT.EMAIL}
                        value={this.state.data !== null ? this.state.data.delivery_email : ''}
                        id={'delivery_email'}
                        className={'w-100'}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <h2 className={'titleAddress'}>{this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].DELIVERY_TYPE}</h2>
                  <Grid container spacing={8}>
                    <Grid item xs={12}>
                      <CustomInput
                        // ref={ref => this.delivery_email = ref}
                        text={this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].DELIVERY_TYPE_TITLE}
                        value={this.state.data.delivery_type.name}
                        id={'delivery_email'}
                        className={'w-100'}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <CustomInput
                        // ref={ref => this.delivery_email = ref}
                        text={this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].DELIVERY_TYPE_PRICE}
                        value={`${this.formatMoney(this.state.data.delivery_type_price)}`}
                        id={'delivery_type_price'}
                        className={'w-100'}
                        disabled
                        align={'right'}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <CustomInput
                        // ref={ref => this.delivery_email = ref}
                        text={this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].DELIVERY_TYPE_PRICE_WITH_VAT}
                        value={`${this.formatMoney(this.state.data.delivery_type_price_with_vat)}`}
                        id={'delivery_type_price_with_vat'}
                        className={'w-100'}
                        disabled
                        align={'right'}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <h2 className={'titleAddress'}>{this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].PAYMENT_TYPE}</h2>
                  <Grid container spacing={8}>
                    <Grid item xs={12}>
                      <CustomInput
                        // ref={ref => this.delivery_email = ref}
                        text={this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].PAYMENT_TYPE_TITLE}
                        value={this.state.data.payment_type.name}
                        id={'payment_type'}
                        className={'w-100'}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <CustomInput
                        // ref={ref => this.delivery_email = ref}
                        text={this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].PAYMENT_TYPE_PRICE}
                        value={`${this.formatMoney(this.state.data.payment_type_price)}`}
                        id={'payment_type_price'}
                        className={'w-100'}
                        disabled
                        align={'right'}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <CustomInput
                        // ref={ref => this.delivery_email = ref}
                        text={this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].PAYMENT_TYPE_PRICE_WITH_VAT}
                        value={`${this.formatMoney(this.state.data.payment_type_price_with_vat)}`}
                        id={'payment_type_price_with_vat'}
                        className={'w-100'}
                        disabled
                        align={'right'}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <h2 className={'titleAddress'}>{this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].LIST_OF_PRODUCTS}</h2>
                  <div className={'tableCustomerOrderDetail'}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell></TableCell>
                          {/* <TableCell>{this.props.translate.i18n.MODULES.PRODUCTS.CODE}</TableCell> */}
                          <TableCell style={{ minWidth: '120px' }}>{this.props.translate.i18n.MODULES.PRODUCTS.CODE}</TableCell>
                          <TableCell style={{ minWidth: '120px' }}>{this.props.translate.i18n.MODULES.PRODUCTS.NAME}</TableCell>
                          <TableCell style={{ cursor: 'pointer' }}>{this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].QUANTITY}</TableCell>
                          <TableCell style={{
                            minWidth: '80px',
                            textAlign: 'right',
                          }}>{this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].ONE_PRICE}</TableCell>
                          <TableCell style={{
                            minWidth: '120px',
                            textAlign: 'right',
                          }}>{this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].ONE_PRICE_WITH_VAT}</TableCell>
                          <TableCell style={{
                            minWidth: '120px',
                            textAlign: 'right',
                          }}>{this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].DISCOUNT}</TableCell>
                          <TableCell style={{
                            minWidth: '100px',
                            textAlign: 'right',
                          }}>{this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].TOTAL_PRICE}</TableCell>
                          <TableCell style={{
                            minWidth: '150px',
                            textAlign: 'right',
                          }}>{this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].TOTAL_PRICE_WITH_VAT}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.data.items.map((item, index) => {
                          return (
                            <TableRow key={item.product_id !== null ? item.product_id : item.static_set_id}>
                              <TableCell className={'first-cell'} style={{
                                width: '50px',
                                paddingLeft: 0,
                                paddingRight: 0,
                              }}>
                                <CustomIconButton
                                  id={item}
                                  label="More"
                                  dropdownMenu
                                  items={this.detail}
                                  module={'/customers-orders'}
                                  aboutItem={item}
                                  data={item}
                                >
                                  <Icon path={mdiDotsVertical} size={1}/>
                                </CustomIconButton>
                              </TableCell>
                              <TableCell>{item.product ? item.product.code : 'FIXED SET'}</TableCell>
                              <TableCell>{item.product !== null && item.static_set === null ? item.product.name : item.static_set.name}</TableCell>
                              {/* <TableCell></TableCell> */}
                              <TableCell>
                                <InputBase type={'number'} defaultValue={item.quantity} onChange={(val) => this.handleChangeQuantity(item, val)}/>
                              </TableCell>
                              <TableCell numeric>{this.formatMoney(item.one_price)}</TableCell>
                              <TableCell numeric>{this.formatMoney(item.one_price_with_vat)}</TableCell>
                              <TableCell numeric>{this.formatMoney(item.discount)}</TableCell>
                              <TableCell numeric>{this.formatMoney(item.total_price)}</TableCell>
                              <TableCell numeric>{this.formatMoney(item.total_price_with_vat)}</TableCell>
                            </TableRow>
                          )
                        })}
                      </TableBody>
                    </Table>
                  </div>
                
                </Grid>
                
                <Grid item xs={12}>
                  <h2 className={'titleAddress'}>{this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].LIST_OF_GIFTS}</h2>
                  <div className={'tableCustomerOrderDetail'}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell style={{ minWidth: '120px' }}>{this.props.translate.i18n.MODULES.GIFTS.NAME}</TableCell>
                          <TableCell style={{ minWidth: '120px' }}>{this.props.translate.i18n.MODULES.GIFTS.PRODUCT}</TableCell>
                          <TableCell style={{ minWidth: '120px' }}>{this.props.translate.i18n.MODULES.GIFTS.STATIC_SET}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.data.gifts.map((gift, index) => {
                          return (
                            <TableRow key={gift.id}>
                              <TableCell>{gift.gift.name}</TableCell>
                              <TableCell>{gift.product ? gift.product.name : '-'}</TableCell>
                              <TableCell>{gift.static_set ? gift.static_set.name : '-'}</TableCell>
                            </TableRow>
                          )
                        })}
                        {this.state.data.gift && (
                          <TableRow key={this.state.data.gift.id}>
                            <TableCell>{this.state.data.gift.name}</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </div>
                
                </Grid>
                <Grid item xs={12}>
                  <h2 className={'titleAddress'}>{this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].SUMMARY}</h2>
                  <CustomInput
                    // ref={ref => this.delivery_email = ref}
                    text={this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].COUPON}
                    value={`${this.state.data.coupon ? this.state.data.coupon.code + ' (' + this.state.data.coupon.name + ')' : 'N/A'}`}
                    id={'coupon'}
                    className={'w-100'}
                    disabled
                    align={'right'}
                  />
                  <CustomInput
                    // ref={ref => this.delivery_email = ref}
                    text={this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].TOTAL}
                    value={`${this.formatMoney(this.state.data.total)}`}
                    id={'total'}
                    className={'w-100'}
                    disabled
                    align={'right'}
                  />
                  <CustomInput
                    // ref={ref => this.delivery_email = ref}
                    text={this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].TOTAL_WITH_VAT}
                    value={`${this.formatMoney(this.state.data.total_with_vat)}`}
                    id={'total_with_vat'}
                    className={'w-100'}
                    disabled
                    align={'right'}
                  />
                </Grid>
              
              </Grid>
            
            </DialogContent>
          }
          <DialogActions>
            <Button onClick={() => this.props.onClose(false)} className={'gray-text'}>
              {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
            </Button>
            <CustomButton
              progressBar={this.state.loadingBtn}
              onClick={this.action}
              mystyle={'btn-white-bg'}
              title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
              justText
              disabled={this.state.loading}
            />
          </DialogActions>
        </Dialog>
      </MuiThemeProvider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/ServiceProtocols/Show/ShowServiceProtocol.jsx